import {
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Fade,
  useTheme,
} from "@mui/material";
import { DeleteOutlined as DeleteOutlineIcon } from "@mui/icons-material";

export const DeleteHistoryDialog = ({
  open,
  onClose,
  onConfirm,
  historyTitle,
  categoryPath,
  isLoading,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slots={{ transition: Fade }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Are you sure you want to delete this history?</DialogTitle>

      <DialogContent
        sx={{
          borderBottom: `1px solid ${theme.palette.gray.medium}`,
          py: 2,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography
            variant="subtitle2"
            sx={{ color: "text.secondary", mt: 0.5 }}
          >
            {historyTitle || "This history item"}
          </Typography>
          <Typography variant="body2">{categoryPath || ""}</Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          p: 2,
          gap: 1,
          justifyContent: "flex-end",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            flex: 1,
            maxWidth: "140px",
            borderColor: theme.palette.gray.medium,
            color: theme.palette.gray.ultraDark,
            "&:hover": {
              borderColor: theme.palette.gray.dark,
              backgroundColor: theme.palette.gray.light,
            },
          }}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="outlined"
          startIcon={!isLoading && <DeleteOutlineIcon />}
          sx={{
            flex: 1,
            maxWidth: "140px",
            borderColor: theme.palette.error.main,
            background: "none",
            color: theme.palette.error.main,
            boxShadow: "none",
            "&:hover": {
              background: theme.palette.error.main,
              color: theme.palette.primary.white,
            },
            "&:disabled": {
              background: "#ccc",
              boxShadow: "none",
            },
          }}
          disabled={isLoading}
        >
          {isLoading ? "Deleting..." : "Yes, Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
